<template>
  <div
    class="component video"
    :data-mode="mode"
    data-viewport
    @click="() => { if (data.content.price) $store.commit('SET_CONTACT', true) }"
    @mouseenter="videoHover(); data.content.price && $store.commit('SET_POINTER', 'pointer')"
    @mouseleave="videoOut(); data.content.price && $store.commit('SET_POINTER', 'default')"
  >
    <div class="video__title" v-if="data.content.title" v-html="data.content.title"></div>
    <div class="video__placeholder" ref="video"></div>
    <div class="video__price" v-if="data.content.price" v-html="data.content.price"></div>
  </div>
</template>

<script>
import gsap from 'gsap';
import WebGLVideo from '@/scripts/webgl/WebGLVideo';
import audio from '@/scripts/audio';
import { isMobile } from '../scripts/utils';

export default {
  name: 'VideoBlock',

  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
    mode: {
      type: String,
      required: false,
      default: () => 'contain',
    },
  },

  data() {
    return {
      audio: null,
      WebGLVideo: null,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.WebGLVideo = new WebGLVideo(
        this,
        this.$refs.video,
        this.data.content.video,
        this.data.content.resource,
      );
      if (isMobile()) this.videoHover(true);
    });
  },

  methods: {
    videoHover(skip = false) {
      if (!this.data.content.price) return;
      this.WebGLVideo.buyIt.alpha = 1;
      this.hover = gsap.to(this.WebGLVideo.buyIt, {
        alpha: 0,
        yoyo: true,
        repeat: -1,
        ease: 'steps(1)',
        duration: 0.5,
      });
      if (!skip) audio.play('buyit');
    },
    videoOut() {
      if (!this.data.content.price) return;
      gsap.killTweensOf(this.WebGLVideo.buyIt);
      this.WebGLVideo.buyIt.alpha = 0;
    },
  },

  beforeDestroy() {
    this.WebGLVideo.destroy();
  },
};
</script>

<style lang="scss" scoped>
.video {
  position: relative;
  width: 100%;

  &__placeholder {
    width: 100%;
    height: 80vh;
    height: calc(var(--vh, 1vh) * 80);

    @include mq($until: ipadL) {
      height: calc(var(--vh, 1vh) * 45);
    }

    @include mq($until: ipadP) {
      width: calc(100% - ((100vw / 32) * 4));
      height: calc(540px * var(--rw));
      margin: $mobile-vertical-padding $mobile-horizontal-padding;
    }
  }

  &[data-mode="half"] {
    .video__placeholder {
      width: calc(960px * var(--rw));
      height: calc(1080px * var(--rw));
      margin: $vertical-padding $extra-horizontal-padding;

      @include mq($until: ipadL) {
        width: calc(100% - (100vw / 32) * 8);
        height: calc(540px * var(--rw));
        margin: $mobile-vertical-padding $extra-mobile-horizontal-padding;
      }
    }
  }

  &[data-mode="padding"] {
    .video__placeholder {
      width: calc(100% - ((100vw / 32) * 4));
      height: calc(1080px * var(--rw));
      margin: $vertical-padding $horizontal-padding;

      @include mq($until: ipadL) {
        height: calc(540px * var(--rw));
        margin: $mobile-vertical-padding $mobile-horizontal-padding;
      }
    }
  }

  &__title {
    margin: 60px 0px;
    font-size: rem(65px);
    font-size: calc(65px * var(--rw));
    line-height: rem(65px);
    line-height: calc(65px * var(--rw));

    text-align: center;
  }

  &__price {
    position: absolute;
    width: 100%;
    bottom: 30px;
    font-family: 'VHS';
    margin: 60px 0px;
    font-size: rem(36px);
    font-size: calc(36px * var(--rw));
    line-height: rem(48px);
    line-height: calc(48px * var(--rw));

    text-align: center;
  }
}
</style>
